import React from 'react'

export default ({ children }) => {
  return (
    <div className="buttons has-addons">
      {children}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/ButtonGroup/ButtonGroup.js